var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_5556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8912 4.99635C11.1193 6.11605 10.9567 7.28012 10.4305 8.29444C9.90424 9.30876 9.04617 10.112 7.99938 10.5703C6.95258 11.0285 5.78032 11.114 4.67809 10.8126C3.57587 10.5111 2.6103 9.84093 1.94241 8.91373C1.27452 7.98653 0.944681 6.85838 1.0079 5.71743C1.07112 4.57647 1.52357 3.49167 2.2898 2.64394C3.05604 1.7962 4.08974 1.23676 5.21852 1.05893C6.3473 0.881088 7.50293 1.0956 8.4927 1.66668",
    stroke: "#008236",
    strokeWidth: 0.99915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 5.49507L5.99482 6.9938L10.9906 1.99805",
    stroke: "#008236",
    strokeWidth: 0.99915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_5556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9898,
    height: 11.9898,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.954ade81b2cf86ca9bedc03d2f8e6539.svg";
export { ForwardRef as ReactComponent };